var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.isEmpty)?[_c('base-alert',{attrs:{"type":"info"}},[_vm._v(" "+_vm._s(_vm.emptyMessage)+" ")])]:[_c('div',{staticStyle:{"overflow-y":"auto","overflow-x":"hidden","max-height":"450px"}},[_vm._t("default")],2)]],2)}
var staticRenderFns = []

export { render, staticRenderFns }